<template>
    <div class="map_navigation">
        <a href="javascript: void(0);" class="map_legend_open">범례</a>
        <ul class="zoom_btn">
            <li class="plus" @click.prevent="mapZoomIn">확대</li>
            <li class="minus" @click.prevent="mapZoomOut">축소</li>
        </ul>
    </div>
</template>

<script>
import { $_TYPE, $_WC, $_NM } from '@/confs/common.const';
import naverMapShareMixins from '@/stores/naver.map.share.mixin';

import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters({
            showLegend: 'getShowLegend',
        }),
    },
    watch: {
    },
    created() {
        this.$eventBus.$on('NaverMap::map-click', map =>{
            if(typeof this.curInfoWindow !== $_TYPE.UNDEF) {
                this.curInfoWindow.close();
            }
        });
    },
    methods: {
    },
    mixins: [naverMapShareMixins],
};
</script>
<style>
</style>